import React from 'react';
import ReactDOM from 'react-dom';
import LandingPage from '../pages/LandingPage';
import "../../less/app.less";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import store from '../redux/store';
import { PrivateRoute } from './PrivateRoute';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../pages/Home';
import Dashboard from '../pages/Dashboard';
import SearchRnc from '../pages/SearchRnc';
import Reports from '../pages/Reports';
import PlatformUsersManagement from '../pages/PlatformUsersManagement';
import ProcessCustomers from '../pages/ProcessCustomers';
import ProcessLaboratory from '../pages/ProcessLaboratory';
import ProcessMedecine from '../pages/ProcessMedecine';
import AccountConfig from '../pages/AccountConfig';
import ProcessVisio from '../pages/ProcessVisio';
import ProcessAudio from '../pages/ProcessAudio';
import SearchCandidat from '../pages/SearchCandidat';
import RpReports from '../pages/RpReports';
import CheckStatus from '../pages/CheckStatus';
import { ConfigProvider } from 'antd';
import QueueDisplay from '../pages/QueueDisplay';
import ReduceHome from '../pages/ReduceHome';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function App() {
  return /*#__PURE__*/_jsx(ConfigProvider, {
    theme: {
      token: {
        colorPrimary: '#EA6A6B',
        colorLink: '#366669',
        borderRadius: "24px"
      }
    },
    children: /*#__PURE__*/_jsx(Router, {
      children: /*#__PURE__*/_jsxs(Routes, {
        children: [/*#__PURE__*/_jsx(Route, {
          exact: true,
          path: "/",
          element: /*#__PURE__*/_jsx(PrivateRoute, {
            children: /*#__PURE__*/_jsx(LandingPage, {})
          })
        }), /*#__PURE__*/_jsx(Route, {
          path: "/bonjour",
          element: /*#__PURE__*/_jsx(LandingPage, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/check/:rnc",
          element: /*#__PURE__*/_jsx(CheckStatus, {})
        }), /*#__PURE__*/_jsxs(Route, {
          path: "home",
          element: /*#__PURE__*/_jsx(Home, {}),
          children: [/*#__PURE__*/_jsx(Route, {
            path: "/home",
            element: /*#__PURE__*/_jsx(Dashboard, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "/home/:userid",
            element: /*#__PURE__*/_jsx(Dashboard, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "dashboard",
            element: /*#__PURE__*/_jsx(Dashboard, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "hs",
            element: /*#__PURE__*/_jsx(ReduceHome, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "queue",
            element: /*#__PURE__*/_jsx(QueueDisplay, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "rpreports",
            element: /*#__PURE__*/_jsx(RpReports, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "searchrnc",
            element: /*#__PURE__*/_jsx(SearchCandidat, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "validate",
            element: /*#__PURE__*/_jsx(SearchRnc, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "processlab",
            element: /*#__PURE__*/_jsx(ProcessLaboratory, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "processmedecine",
            element: /*#__PURE__*/_jsx(ProcessMedecine, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "processvisio",
            element: /*#__PURE__*/_jsx(ProcessVisio, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "processaudio",
            element: /*#__PURE__*/_jsx(ProcessAudio, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "accountconfig",
            element: /*#__PURE__*/_jsx(AccountConfig, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "reports",
            element: /*#__PURE__*/_jsx(Reports, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "users",
            element: /*#__PURE__*/_jsx(PlatformUsersManagement, {})
          })]
        })]
      })
    })
  });
}
export default App;
if (document.getElementById('app')) {
  ReactDOM.render( /*#__PURE__*/_jsx(Provider, {
    store: store,
    children: /*#__PURE__*/_jsx(App, {})
  }), document.getElementById('app'));
}